import React, { useState } from "react";
import { handlePauseAllVideo, removeStylesFromHtml } from "../../../utils";
import { ReactComponent as ArrowUpIcon } from "../../../Icons/arrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "../../../Icons/arrowDown.svg";
import { ReactComponent as RFUIcon } from "../../../Icons/rfuIcon.svg";
import { ReactComponent as VerifyIcon } from "../../../Icons/verify.svg";
import { ReactComponent as CopyIcon } from "../../../Icons/copy.svg";
import Voting from "../../Voting/Voting";
import Button2 from "../../Button2/Button2";
import { useDispatch, useSelector } from "react-redux";
import { requestForUpdate } from "../../../API/api";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import ImgCarousal from "../../Carousal/carousal";
import Button from "../../Button/Button";
import Thread from "./Thread";
import VideoBox from "./VidexBox";
import { CURRENT_ROLE } from "../../../API/url";

const contentStyle = {
  border: "1px solid #E0E2E6",
  borderRadius: "16px",
  boxShadow: "0px 4px 16px 0px #1018280F",
};
export default function Answer({ data, question }) {
  // console.log('hi')
  const randomNumber = Math.random()*10;
  const dispatch = useDispatch();
  const {advanceFilterModalToggle, getSelectedQuestion, getSelectedAnswer} = bindActionCreators(Actions, dispatch)
  const successfulHelpful = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>{message}</span>
      </>
    );
  };
  const userState = useSelector((state) => state.user);
  const [permission, setPermission] =useState(userState.roles.find(data=>data.roleName===CURRENT_ROLE).permissions.find(item=>item.id===9));
  const searchState = useSelector((state) => state.search);
  const [isAccept, setAccept] = useState(null);
  const [isPlay, setPlay] = useState(false);
  const [isShow, setShow] = useState(false);
  const trimString = (str) => {
    if (str.length > 350) {
      return str.slice(0, 350) + "...";
    }
    return str;
  };
  const ansStyles = {
    marginTop: "10px",
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "24px",
    fontWeight: "300",
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  };
  const showMoreStyles = {
    fontSize: "15px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "400",
    background:
      "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    backgroundClip: "text",
    "-webkit-text-fill-color": "transparent",
    "-moz-text-fill-color": "transparent",
    "-ms-text-fill-color": "transparent",
    "-o-text-fill-color": "transparent",
    cursor: "pointer",
    marginTop: "5px",
  };
  const onClickVote = (key) => {
    setAccept(key);
    let payload = {
      questionUuid: question.questionUuidCopy,
      answerUuid: data.answerUuid,
      status: key === 1 ? "accepted" : "reject",
      questionText: searchState.inputValue,
    };
    if (question.docType === "expertqa") {
      payload["botQuestionText"] = question.question;
      payload["answerText"] = data.answerCopy;
      // payload["pdfId"] = "";
    } else if (question.docType === "Thread") {
      payload["answerText"] = data.threads.join(",");
      // payload["pdfId"] = "";
    } else {
      payload["answerText"] = data.answerCopy;
      // payload["pdfId"] = data?.attachments[0]?.name?.split(".")[0];
    }
    searchState.docData.filter(obj=>{
      obj.answers.filter(ans=>{
        if(ans.answerUuid===data.answerUuid){
          if(key !==1){
            ans.isReject= true;
            ans.isHelpful= false;
          }else{
            ans.isHelpful= true;
            ans.isReject= false;
          }
        }
      })
      return obj;
    })
    searchState.origRawSearchedData.filter(obj=>{
      obj.answers.filter(ans=>{
        if(ans.answerUuid===data.answerUuid){
          if(key !==1){
            ans.isReject= true;
            ans.isHelpful= false;
          }else{
            ans.isHelpful= true;
            ans.isReject= false;
          }
        }
      })
      return obj;
    })
    requestForUpdate(payload)
      .then((res) => {
        if (res !== undefined) {
          toast.success(successfulHelpful(res.data.message), {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((err) => {});
  };
  const onClickButton = (key) => {
    // console.log("clicked the rating");
  };
  const onClickShareButton = () => {
    advanceFilterModalToggle({ bool: true, value: "shareQuestion" });
    getSelectedQuestion(question);
  };
  const onClickRFU = () => {
    advanceFilterModalToggle({ bool: true, value: "requestForUpdate" });
    getSelectedAnswer(data);
    getSelectedQuestion(question);
  };
  const stripHtml=(htmlString)=>{
    return htmlString
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n\n")
    .replace(/<\/?[^>]+(>|$)/g, "");
  }
const onClickCopy=(text)=>{
    let newString = stripHtml(data.answerText);
    navigator.clipboard.writeText(newString);
}
const onClickPlayPause=()=>{
  setPlay(!isPlay);
}
const firstThread = {
  width: "95%",
  minHeight: "44px",
  border: ` 1px solid #E0E2E6`,
  padding: "10px 12px 10px 12px",
  borderRadius: "8px",
  background: "#F6F7F8",
  color: "#2A364A",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: "300",
  marginLeft: "5%",
  marginBlock: "5px",
  wordBreak: 'break-word',
  overflowWrap: 'break-word',
};
// console.log("question");
  return (
    <>
    {data.threads !== null && question.docType ==='Thread'  && <Thread type={'thread'} thread={data.threads} isShow={isShow} isReusable={question.threadType==='REUSABLE_THREAD_QA'?true:false}/>}
    {question.docType==='Email' && <div>
      <div  style={firstThread} dangerouslySetInnerHTML={{
                  __html:question.question,
                }}></div>
                <div  style={firstThread} dangerouslySetInnerHTML={{
                  __html:data.answerText,
                }}></div>
      </div>}
    {data.threads !== null && question.docType ==='Email'  && <Thread type={'email'} thread={data.threads} isShow={isShow} isReusable={false}/>}
    { data.attachmentURL && data.attachmentURL.length > 0 && (
            <div className="mb-4 mt-3">
              <div>
              <ImgCarousal data={data.attachmentURL}/>
              </div>
            </div>
          )}
      {question.docType==='Video' && <VideoBox ques={question} data={data} />}
      {data.threads===null && <div
        style={ansStyles}
        dangerouslySetInnerHTML={{
          __html: !isShow
            ? removeStylesFromHtml(
                trimString(
                  data.answerText === null
                    ? question.contextData
                    : data.answerText
                )
              )
            : removeStylesFromHtml(
                data.answerText === null
                  ? question.contextData
                  : data.answerText
              ),
        }}
      ></div>}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <div>
          {data.threads===null && data.answerText && data.answerText.length > 350 &&
              !isShow && (
                <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                  Show more&nbsp;
                  <ArrowDownIcon />
                </div>
              )}
          {data.threads ===null && data.answerText &&
             data.answerText.length > 350 &&
              isShow && (
                <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                  Show less&nbsp;
                  <ArrowUpIcon />
                </div>
              )}
              {question.docType==='Thread' && data.threads !==null && question.threadType==='REUSABLE_THREAD_QA' &&
              !isShow && (
                <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                  Show full thread&nbsp;
                  <ArrowDownIcon />
                </div>
              )}
          {question.docType==='Thread' && data.threads !==null && question.threadType==='REUSABLE_THREAD_QA' &&
              isShow && (
                <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                  Hide full thread&nbsp;
                  <ArrowUpIcon />
                </div>
              )}
              {question.docType==='Email' && data.threads !==null  &&
              !isShow && (
                <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                  Show full email&nbsp;
                  <ArrowDownIcon />
                </div>
              )}
          {question.docType==='Email' && data.threads !==null &&
              isShow && (
                <div onClick={() => setShow(!isShow)} style={showMoreStyles}>
                  Hide full email&nbsp;
                  <ArrowUpIcon />
                </div>
              )}
        </div>
        {question.docType !== "Email" && (
          <div style={{ display: "flex", alignItems: "center" }}>
            {CURRENT_ROLE !=='Expert' && permission !== undefined && data.isVerifyShow === undefined && <Button2 type={"dark"} onClickFunc={onClickRFU}>
              <VerifyIcon  />
              &nbsp;Verify
            </Button2>}
            &nbsp;
            <Button2 onClickFunc={onClickButton}>
              <Voting value={data.isHelpful===true?1:data.isReject===true?0:null} onClickFunc={onClickVote} />
            </Button2>
          </div>
        )}
      </div>
    </>
  );
}
